import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IRollesQueryShapes, RollesQueryFilterConfig } from 'fa-kt.types';
import { RollesService } from '../service';

@Component({
  selector: 'fa-kt-rolles-filter',
  templateUrl: './rolles-filter.component.html',
  styleUrls: ['./rolles-filter.component.css'],
})
export class RollesFilterComponent {
  readonly subscriptions: Subscription[] = [];

  RollesFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public rolles: RollesService,
  ) {
    this.RollesFilterConfig = RollesQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.rolles.shapes$.subscribe((shapes: IRollesQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.RollesFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.RollesFilterConfig[index].selections = shapes;
  }
}
